import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { PaymentPage, QueryPaymentsArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryPaymentsArgs;
type TData = PaymentPage;

const MOCK: TVariables = {
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined
};

export const usePayments = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query Payments(
      $sortAttribute: PaymentSortAttributeEnum
      $sortOrder: SortOrderEnum
      $page: Int
      $perPage: Int
    ) {
      payments(
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        page: $page
        perPage: $perPage
      ) {
        nodes {
          id
          amountInCents
          createdAt
          currency
          invoice {
            id
          }
          status
          type
        }
        nodesCount
        pagesCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['payments', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      await client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
